import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getDBSLogs } from '../../../actions/chains'

import { renderFullDate } from '../../../utils/time'
import { translation } from '../../../utils/helpers'

import TableContainer from '../../../shared/elements/tableContainer'
import TableRow from '../../../shared/elements/tableRow'

class DBSLog extends Component {

  constructor (props) {
    super(props)
    this.state = {
      list: []
    }
    this.renderItem = this.renderItem.bind(this)
    this.cols = ['1fr', '1fr', '1fr', '1fr']
  }

  componentDidMount () {
    this.getDBSLogs()
  }

  getDBSLogs () {
    this.props.getDBSLogs(this.props.integrationType).then((res) => {
      this.setState({
        list: res.data
      })
    }, () => {
      window.toastr.error(translation('910'), translation('216'))
      this.props.router.push('/')
    })
  }

  renderItem (item, key) {
    return (
      <TableRow cols={this.cols}>
        <div>{renderFullDate(item.DateTime)}</div>
        <div>{item.CompanyName}</div>
        <div>{translation(item.ResponseType)}</div>
        <div>{item.EstimateNumber}</div>
      </TableRow>
    )
  }

  render () {
    return (
      <TableContainer>
        <TableRow header cols={this.cols}>
          <div>{translation(388)}</div>
          <div>{translation(700)}</div>
          <div>{translation(18166)}</div>
          <div>{translation(13427)}</div>
        </TableRow>
        {this.state.list.map(this.renderItem)}
      </TableContainer>
    )
  }
}

export default connect(null, {
  getDBSLogs
})(DBSLog)



// WEBPACK FOOTER //
// ./src/app/pages/IntegrationErrorList/pages/dbsLog.js